
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[city]/pod-zalog-kvartiry",
      function () {
        return require("private-next-pages/[city]/pod-zalog-kvartiry.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[city]/pod-zalog-kvartiry"])
      });
    }
  